import React from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function FilterModal({
  show,
  onHide,
  applyFilter,
  removeFilter,
  apidata,
  monthFilter,
  setMonthFilter,
}) {
  // Get unique months from apidata
  const uniqueMonths =
    apidata && apidata.length > 0
      ? [...new Set(apidata.map((item) => item.report_month))].filter(Boolean)
      : [];

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Filter Options</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group controlId="monthFilter">
            <Form.Label>Select Report Month</Form.Label>
            <Form.Control
              as="select"
              value={monthFilter}
              onChange={(e) => setMonthFilter(e.target.value)}
            >
              <option value="">All Months</option>
              {uniqueMonths.map((month, index) => (
                <option key={index} value={month}>
                  {month}
                </option>
              ))}
            </Form.Control>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={removeFilter}>
          Remove Filters
        </Button>
        <Button variant="primary" onClick={applyFilter}>
          Apply Filters
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
